import { useNavigate, useRouter } from '@tanstack/react-router';
import { Icon } from './Icon';

/**
 * Vissza a listahoz - CSAK mobilon.
 *
 * Mobilon a kezdolap a csatornak es a beszelgetesek listaja, es a tartalom
 * ezt fedi el. Enelkul a gomb nelkul az ember bent ragadna: az oldalsav ott
 * nem latszik oldalt, ahonnan masik beszelgetest lehetne valasztani.
 *
 * VISSZALEP az elozmenyben, nem uj lepest tesz (K2): eddig minden koppintas
 * egy uj "/" bejegyzest hagyott, es a telefon vissza-mozdulata utana
 * oda-vissza ugralt a csatorna es a lista kozott. Ha nincs hova visszalepni
 * (ertesitesbol nyilt a csatorna), a listara visz, a helyere.
 *
 * Asztalon nincs ra szukseg (`md:hidden`): ott a lista vegig latszik.
 */
export function MobileBack() {
  const router = useRouter();
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => {
        if (router.history.canGoBack()) router.history.back();
        else void navigate({ to: '/', replace: true });
      }}
      title="Vissza a listához"
      aria-label="Vissza a listához"
      className="-ml-1 grid size-9 shrink-0 place-items-center rounded-control text-ink-muted transition-colors duration-(--duration-quick) hover:bg-surface-hover hover:text-ink md:hidden"
    >
      <Icon name="nyilBalra" />
    </button>
  );
}
